<script>
import { cloneDeep } from 'lodash-es';
import ValidatorMixin from '../../mixins/validatorMixin';

export default {
  name: 'itinerary-seo-teaser-list',
  props: {
    itineraryId: {
      type: Number,
      required: true,
    },
    seoLoading: {
      type: Boolean,
      default: false,
    },
    seoTeaserItems: {
      type: Array,
      default: () => [],
    },
    seoTeaserError: {
      type: Boolean,
      default: false,
    },
    selectedDomain: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      localSeoTeaserItems: [],
      headers: [
        { text: this.$t('itinerary.edit.seo.table.no'), sortable: false },
        { text: this.$t('itinerary.edit.seo.table.description'), sortable: false },
        { text: this.$t('itinerary.edit.seo.table.actions'), sortable: false, align: 'center' },
      ],
      valid: true,
    };
  },
  created() {
    this.localSeoTeaserItems = cloneDeep(this.seoTeaserItems);
  },
  methods: {
    save() {
      this.$emit('saveTeasers', this.localSeoTeaserItems);
    },
  },
  watch: {
    seoTeaserItems() {
      this.localSeoTeaserItems = cloneDeep(this.seoTeaserItems);
    },
  },
  mixins: [ValidatorMixin],
};
</script>

<template>
  <v-container class="pa-0 fluid">
    <v-card-title class="pb-0">
      <div class="headline">{{ $t('itinerary.edit.seo.table.title') }}</div>
    </v-card-title>

    <v-layout row wrap>
      <v-flex class="my-4">
        <v-form v-model="valid">
          <v-data-table
            :items="localSeoTeaserItems"
            :headers="headers"
            :loading="seoLoading"
            hide-actions
            class="elevation-1"
          >
            <template v-slot:items="props">
              <tr>
                <td>
                  <template v-if="props.index == 0">
                    {{ $t('itinerary.edit.seo.table.iterator', [props.index + 1]) }} (main page)
                  </template>
                  <template v-else>
                    {{ $t('itinerary.edit.seo.table.iterator', [props.index]) }} (tag line)
                  </template>
                </td>
                <td v-if="props.index == 0">
                  <v-textarea
                    v-model="props.item.description"
                    :label="$t('itinerary.edit.seo.table.description')"
                    class="my-3"
                    counter="8000"
                  />
                  <v-textarea
                    v-if="selectedDomain"
                    v-model="props.item.domains[''+selectedDomain.domainId]"
                    :label="$t('itinerary.edit.seo.table.localDescription')"
                    class="my-3"
                    counter="8000"
                  />
                </td>
                <td v-else>
                  <v-text-field
                    v-model="props.item.description"
                    :label="$t('itinerary.edit.seo.table.description')"
                    class="my-3"
                  />
                  <v-text-field
                    v-if="selectedDomain"
                    v-model="props.item.domains[''+selectedDomain.domainId]"
                    :label="$t('itinerary.edit.seo.table.localDescription')"
                    hide-details
                    class="my-3"
                  />
                </td>
                <td class="text-xs-center">
                  <v-btn
                    fab
                    small
                    depressed
                    color="error"
                    @click="localSeoTeaserItems.splice(props.index, 1)"
                  >
                    <v-icon>delete</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
          <v-btn
            :loading="seoLoading"
            color="success"
            class="right mr-4 mt-4"
            @click="localSeoTeaserItems.push( { id:null, itineraryId, description:'', domains:{} })"
          >
            {{ $t('buttons.add') }}
            <v-icon class="ml-1">add</v-icon>
          </v-btn>
          <v-btn
            :loading="seoLoading"
            color="primary"
            class="right mr-4 mt-4"
            @click="save"
          >
            {{ $t('buttons.save') }}
            <v-icon class="ml-1">save</v-icon>
          </v-btn>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style lang="scss" scoped>
  @import '../../assets/scss/variables.scss';

  .expanded-row {
    position: relative;
    display: table-row;
    height: $expanded-row-height;
    width: 100%;
    overflow: hidden;
  }

  .expanded-row-input {
    margin-top: $margin-lg;
    margin-left: $margin-lg;
    width: $expanded-row-input-width;
  }

  .expanded-row-data {
    position: absolute;
    width: 100%;
    height: $expanded-row-height;
    overflow: auto;
  }

  .expanded-row-form {
    width: 50%;
    float: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/itinerary/ItinerarySEOTeaserList.vue